import { FaEnvelope, FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

/**
 * Shared links for the homepage “Stay in the loop” section and footer “Tail us”.
 * Use `getStayInformedHref(item, isLoggedIn)` for the resolved URL.
 */
export const STAY_INFORMED_ITEMS = [
  {
    key: 'email',
    title: 'Email alerts',
    subtitle: 'Picks of the Day & Parlay in your inbox',
    getHref: (loggedIn) =>
      loggedIn ? '/profile#email-notifications' : '/register',
    external: false,
    accent: '#4299e1',
    Icon: FaEnvelope,
  },
  {
    key: 'instagram',
    title: 'Instagram',
    subtitle: 'Follow @slickpicksbet',
    href: 'https://www.instagram.com/slickpicksbet/',
    external: true,
    accent: '#E1306C',
    Icon: FaInstagram,
  },
  {
    key: 'ig-channel',
    title: 'Instagram channel',
    subtitle: 'Join our broadcast channel',
    href: 'https://www.instagram.com/channel/AbaWVHmSW0lqSXWy/?igsh=NnlnNmQ2ZzZ0bW5s',
    external: true,
    accent: '#c13584',
    Icon: FaInstagram,
  },
  {
    key: 'x',
    title: 'X (Twitter)',
    subtitle: '@slickpicksbet',
    href: 'https://x.com/slickpicksbet',
    external: true,
    accent: '#1d9bf0',
    Icon: FaXTwitter,
  },
];

/** Resolve router path or external URL for a stay-informed item. */
export function getStayInformedHref(item, isLoggedIn) {
  if (item.external && item.href) return item.href;
  if (item.getHref) return item.getHref(isLoggedIn);
  return '/register';
}
